//运输统计签认单
export default [{
  path: 'transportSignManage',
  name: 'transportSignManage',
  component: function component() {
    return import('@/views/transportManage/transportSign/list');
  }
}, {
  path: 'transportSignDetail',
  name: 'transportSignDetail',
  component: function component() {
    return import('@/views/transportManage/transportSign/detail');
  }
}, {
  path: 'weightTransportSummary',
  name: 'weightTransportSummary',
  component: function component() {
    return import('@/views/transportManage/weightTransport/summary');
  }
}, {
  path: 'weightTransportSummaryList',
  name: 'weightTransportSummaryList',
  component: function component() {
    return import('@/views/transportManage/weightTransport/summaryList');
  }
}];
export var activeMenu = {
  '/main/transportSignDetail': '/main/transportSignManage'
};